/* eslint-disable max-lines */
import { useEffect, useState } from "react";
import { Outlet, useLoaderData, useNavigate, useOutletContext } from "react-router-dom";
import { NoDataMessage } from "../../components/DOAAuditReportComponents/NoDataMessage";
import { doFetch } from "../../utils/doFetch";
import { ISummary } from "./UnionAuditReportData";
import { CheckboxFilters } from "./UnionAuditReportModels";
import { UnionAuditReportResultsDetails } from "./UnionAuditReportResultsDetails";
import { UnionAuditReportResultsSummary } from "./UnionAuditReportResultsSummary";

export const UnionAuditReportResultsRouteLoader = async ({ request, params }: { request: any, params: any }) => {
  const data = await doFetch(`audit-report/union/${params.date}/${params.reportDispatchType}`, { signal: request.signal }, true, false);
  return {
    date: params.date,
    reportDispatchType: params.reportDispatchType,
    ...data
  }
}

export const UnionAuditReportResultsRoute = () => {
  const data = useLoaderData();
  return <Outlet context={data} />;
}

export const UnionAuditReportResultsSummaryRoute = () => {
  const data = useOutletContext() as ISummary;
  const navigate = useNavigate();

  const handleDetailNavigation = () => {
    navigate(`/union-audit-report-results/${data.date}/${data.reportDispatchType}/details`);
  }

  if (!data.selectedDispatchInfo) {
    return <NoDataMessage />
  }
  return (
    <UnionAuditReportResultsSummary
      onDetailsButtonClick={handleDetailNavigation}
      data={data}
    />
  )
}

export const UnionAuditReportResultsDetailsRoute = () => {
  const data = useOutletContext() as ISummary;
  const [selectedFilters, setSelectedFilters] = useState<number[]>([]);
  const [filteredData, setFilteredData] = useState(data.details);
  const [page, setPage] = useState(1);
  const pageSize = 10;

  useEffect(() => {
    // filter by dispatch status
    let filtered = data?.details?.filter(d => {
      // if no filter selected, return all result
      if (selectedFilters.length <= 0) return true;
      // ignore availability filter here if it is the only filter selected
      if (selectedFilters.length === 1 && selectedFilters[0] === 5) return true;
      if (selectedFilters.includes(d.filterStatus)) return true;
      return false;
    });
    // filter by availability
    if (selectedFilters.includes(5)) {
      filtered = filtered.filter(d => {
        return d.unavailableReason.length <= 0
      })
    }
    setFilteredData(filtered);
    // reset page to 1
    setPage(1);
  }, [data.details, selectedFilters])

  const handlePageChange = (page: number) => setPage(page);

  const handleFilterSelect = (filter: number) => {
    if (selectedFilters.includes(filter)) {
      const newFilters = selectedFilters.filter(f => f !== filter);
      setSelectedFilters(newFilters);
    } else {
      setSelectedFilters([...selectedFilters, filter]);
    }
  }

  if (!data.selectedDispatchInfo) {
    return <NoDataMessage />
  }
  return (
    <UnionAuditReportResultsDetails
      selectedDispatchInfo={data.selectedDispatchInfo}
      data={filteredData}
      filters={CheckboxFilters}
      selectedFilters={selectedFilters}
      page={page}
      pageSize={pageSize}
      onFilterSelect={handleFilterSelect}
      onPageChange={handlePageChange}
    />
  )
}